import React from 'react';

import { reduxActions, RootState } from '../../store'
import { connect, ConnectedProps } from 'react-redux'

import { withRouter, RouteComponentProps, Switch, Route } from 'react-router-dom';

import TopbarMenu from './TopbarMenu/TopbarMenu';
import SidebarMenu from './SidebarMenu/SidebarMenu';

import usersService from '../../services/users.service';
import { SessionState } from '../../store/session/types';
import { Toast } from 'primereact/toast';
import NotFound from '../ErrorPages/NotFound/NotFound';
import routes from '../../routes';
import RoutingManager from './RoutingManager/RoutingManager';
import Breadcrumbs from './Breadcrumb/Breadcrumb';

import alternaLogo from '../../assets/images/logo-alterna.png';

import { AbilityContext } from '../../shared/CASL/can';
import Unauthorized from '../ErrorPages/Unauthorized/Unauthorized';
import rolesService from '../../services/roles.service';
import featuresService from '../../services/features.service';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import { Refreshable } from 'react-router-refreshable';
import arxeiaConfigurationsService from '../../services/arxeiaConfigurations.service';
import uorsService from '../../services/uors.service';
import fieldsService from '../../services/fields.service';
import searchService from '../../services/search.service';

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    isMobile: state.sessionReducer.isMobile,
    isTablet: state.sessionReducer.isTablet,
    sidebarMenuIsOpen: state.sessionReducer.sidebarMenuIsOpen,
    aooMenuIsOpen: state.sessionReducer.aooMenuIsOpen,
})

const mapDispatch = {
    updateSession: (newSessionState: Partial<SessionState>) => (reduxActions.sessionActions.updateSession(newSessionState)),
    setPreviousLocationPathName: (previousLocationPathName: string) => (reduxActions.appNavigationActions.setPreviousLocationPathName(previousLocationPathName)),
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface LayoutProps {
}
type Props = LayoutProps & RouteComponentProps & PropsFromRedux


export interface LayoutState {
}

export const toastRef = React.createRef<Toast>();
class Layout extends React.Component<Props, LayoutState> {

    state = {
    }

    componentDidMount() {
        this.setLayoutProperties();
        usersService.getUserInfo()
            .then(user => {
                rolesService.getAllRoles()
                    .then(roles => {
                        //this.setState({ allRoles: roles });
                        this.props.updateSession({ currentUser: user, allRoles: roles });
                        this.getFeatures();
                        this.getArxeiaConfigurations();

                    });

            });


    }

    componentDidUpdate(oldProps: Props, oldState: LayoutState) {
        if (oldProps.currentAoo !== this.props.currentAoo) {
            this.getOrganigrammaAooFlat();
            this.getTuttiIProtocolliViewFields();
            this.getFieldsCampiProtocollo();
            this.getSerchAiFields();
        }

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.props.setPreviousLocationPathName(this.props.location.pathname)
        }
    }

    getFeatures() {
        featuresService.getFeatures()
            .then(features => {
                this.props.updateSession({ features: features });
            });
    }
    getArxeiaConfigurations() {
        arxeiaConfigurationsService.getArxeiaConfigurations()
            .then(configurations => {
                this.props.updateSession({ arxeiaConfigurations: configurations });
            });
    }

    getOrganigrammaAooFlat() {
        if (this.props.currentAoo) {
            uorsService.getOrganigrammaFlat(this.props.currentAoo!.id)
                .then(uors => {
                    this.props.updateSession({ organigrammaFlat: uors });
                });
        }
    }
    getTuttiIProtocolliViewFields() {
        if (this.props.currentAoo) {
            fieldsService.getFieldsByViewName(this.props.currentAoo!.id, 'Tutti i protocolli')
                .then(campi => {
                    this.props.updateSession({ tuttiIProtocolliViewFields: campi });
                })
                .catch(error => {
                    this.props.updateSession({ tuttiIProtocolliViewFields: [] });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: "Attenzione",
                            detail: "Non \u00e8 stato possibile recuperare i campi dei protocolli. Aggiornare la pagina.",
                            life: 5000
                        });
                    }
                });
        }
    }
    getFieldsCampiProtocollo() {
        if (this.props.currentAoo) {
            fieldsService.getFieldsByViewName(this.props.currentAoo!.id, 'Campi protocollo')
                .then(campi => {
                    this.props.updateSession({ campiProtocolloViewFields: campi });
                });
        }
    }

    getSerchAiFields() {
        if (this.props.currentAoo) {
            searchService.getSearchAiFields()
                .then(campi => {
                    this.props.updateSession({ serchAiFields: [...campi] });
                });
        }
    }

    setLayoutProperties() {

        const width = window.innerWidth;
        let tablet = width < 1024 && width >= 640;
        let mobile = width < 640;
        let sidebarMenuOpen = tablet === true || mobile === true ? false : true
        this.props.updateSession({ isTablet: tablet, isMobile: mobile, sidebarMenuIsOpen: sidebarMenuOpen });
    }



    render() {
        let layoutWrapperClasses = "layout-wrapper layout-menu-static";
        if (this.props.sidebarMenuIsOpen === false) {
            layoutWrapperClasses = "layout-wrapper layout-menu-static layout-menu-static-inactive";
        }

        let isErrorPage = this.props.location.pathname === "/notfound" || this.props.location.pathname === "/unauthorized";
        let appVersion = sessionStorage.getItem('packageVersion');

        return (
            <React.Fragment>
                <Toast ref={toastRef} baseZIndex={1000000} />
                {!this.props.currentAoo && !isErrorPage &&
                    <div style={{ position: 'relative', height: '100%' }}>
                        <CircleLoader loaderClass='loader-large' loading={true} />
                    </div>
                }
                <div className={layoutWrapperClasses}>

                    <div className="layout-navigation-menu" >
                        <TopbarMenu />
                        <SidebarMenu />
                    </div>

                    <div className="layout-content">
                        <Refreshable>
                            <Switch>
                                <Route path="/notfound" component={NotFound} />
                                <Route path="/unauthorized" component={Unauthorized} />
                                {routes.map(({ path, Component, key, exact }) => (


                                    <Route path={path} key={key} exact={exact}
                                        render={props => {
                                            return (
                                                <React.Fragment>
                                                    <RoutingManager />
                                                    <Breadcrumbs {...props} />
                                                    <Component {...props} />
                                                </React.Fragment>
                                            );
                                        }}
                                    >
                                    </Route>

                                ))}
                                <Route component={NotFound} />
                            </Switch>
                        </Refreshable>
                        <div className="layout-footer" >
                            <div className="footer-start">
                                <img src={alternaLogo} alt="logo" className="logo w-auto" />

                            </div>
                            <div className="footer-right">
                                <span>© Arxeia 365 - Protocollo</span>
                                <span className="ml-2">{appVersion}</span>
                            </div>
                        </div>

                    </div>
                </div>


            </React.Fragment >
        );
    }
}


export default connector(withRouter(Layout));


Layout.contextType = AbilityContext;

